/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren, useRef } from 'react';
import { jsx, css } from '@emotion/react';
import {
  createDecorator,
  Field,
  Form, MoneyInput,
  validate,
} from 'components/form';
import * as yup from 'yup';
import { FormattedMessage, useIntl } from 'components/i18n';
import Textarea from '@atlaskit/textarea';
import Textfield from '@atlaskit/textfield';
import { RadioGroup, Radio } from '@atlaskit/radio';
import { Account } from './GeneralLedgerPage';
import { Checkbox } from '@atlaskit/checkbox';


const defaultProps = {};

type Props = {
  id?: string;
  onSubmit: (account: Account) => any;
  initialValues: Account;
} & typeof defaultProps;

const schema = yup.object({
  type: yup.string().required('Required')
});

const accountTypeOptions = [
  {
    name: 'type',
    value: 'ASSET',
    label: 'ASSET',
  },
  {
    name: 'type',
    value: 'LIABILITY',
    label: 'LIABILITY',
  },
  {
    name: 'type',
    value: 'EQUITY',
    label: 'EQUITY',
  },
  {
    name: 'type',
    value: 'EXPENSE',
    label: 'EXPENSE',
  },
  {
    name: 'type',
    value: 'REVENUE',
    label: 'REVENUE',
  },
];

// const vatCodeDecorator = createDecorator({
//   field: /vatCode/, // when vatCode changes set vatCodeId
//   updates: {
//     vatCodeId:  (vatCode: any, allValues: Object | undefined)  => vatCode.id || '',
//   },
// });


const CheckboxField =  (props: any) => <Checkbox {...props}  isChecked={props.checked}></Checkbox>;

const AccountForm = ({onSubmit, initialValues, id}: PropsWithChildren<Props>) => {
  const isNew = !initialValues.accountNumber;
  const intl = useIntl();
  return (
    <Form<Account>
      onSubmit={(values) => onSubmit(values)}
      initialValues={initialValues}
      validate={validate(schema)}
    >
      {({ handleSubmit, values, form }) => {
        const { type } = values;
        const isService = type === 'service';
        return (
          <form onSubmit={handleSubmit}>
            <button id={id || 'accountForm'} type={"submit"} style={{display: 'none'}}>Submit</button>
            <Field name="type" label="Type">
              {({ input }) => (
                <div
                  css={css`
                  display: flex;
                  justify-content: space-between;
                `}
                >
                  <div
                    css={css`
                    display: flex;
                    margin-left: -5px;
                  `}
                  >
                    <RadioGroup options={accountTypeOptions} {...input} />
                  </div>
                </div>
              )}
            </Field>

            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.accountNumber"
                  defaultMessage="Account number"
                />
              }
              autoFocus
              name="accountNumber"
              component={Textfield}
            />
            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.description"
                  defaultMessage="Description"
                />
              }
              name="description"
              component={Textarea}
              rows={1}
              minimumRows={1}
            />
            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.active"
                  defaultMessage="Active"
                />
              }
              type="checkbox"
              name="active"
            >
                {({input, error }) => {
                  return (
                    <Checkbox {...input}  isChecked={input.checked}></Checkbox>
                  )
                }}
            </Field>
            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.eenmanszaak"
                  defaultMessage="Eenmanszaak"
                />
              }
              type="checkbox"
              name="eenmanszaak"
              component={CheckboxField}
            />
            <Field
            label={
              <FormattedMessage
                id="admin.AccountForm.vof"
                defaultMessage="VOF"
              />
            }
            type="checkbox"
            name="vof"
            component={CheckboxField}
          />
            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.bv"
                  defaultMessage="BV"
                />
              }
              type="checkbox"
              name="bv"
              component={CheckboxField}
            />
            <Field
              label={
                <FormattedMessage
                  id="admin.AccountForm.subCategoryNumber"
                  defaultMessage="Subcategory number"
                />
              }
              name="subCategoryNumber"
              component={Textfield}
            />
          </form>
        );
      }}
    </Form>
  );
};

AccountForm.defaultProps = defaultProps;

export default AccountForm;
